import React, { useState } from "react";
import "../styles/captionAI.scss";
import CaptionAIForm from "../captionAI/form/captionAI-form.jsx";

const CaptionAIPreviewApp = () => {
  const [loadSession, setLoadSession] = useState(null);

  return (
    <div className="captionAI-container empty">
        <CaptionAIForm
          authenticated={false}
          preview={true}
          setLoadSession={setLoadSession}
          loadSession={loadSession}
        />
    </div>
  );
};

export default CaptionAIPreviewApp;
